import { render, staticRenderFns } from "./InstructionalVideo.vue?vue&type=template&id=9cb68ae2&"
import script from "./InstructionalVideo.vue?vue&type=script&lang=js&"
export * from "./InstructionalVideo.vue?vue&type=script&lang=js&"
import style0 from "./InstructionalVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports